export const CHANGE_BOOK_BACKGROUND_COLOR = 'CHANGE_BOOK_BACKGROUND_COLOR';
export const LOAD_EDITOR_UI_BOOK_PROPERTIES = 'LOAD_EDITOR_UI_BOOK_PROPERTIES';

export const CHANGE_BOOK_BACKGROUND_IMAGE = 'CHANGE_BOOK_BACKGROUND_IMAGE';
export const CHANGE_BOOK_BACKGROUND_TYPE = 'CHANGE_BOOK_BACKGROUND_TYPE';
export const LOAD_BOOK_BACKGROUND_TYPE = 'LOAD_BOOK_BACKGROUND_TYPE';



// WEBPACK FOOTER //
// ./src/redux/action-types/ui/bookProperties.js